// BF library of actions
import { socket } from "Js/feathers"; //app, scriptService
// import { actions } from "Js/actionsProcessor";
// import { EventBus } from "Js/eventBus";
// import router from "Js/routes.js";
// import runHook from "Js/hookHandler";
import { Uuid } from 'Js/bfUtilities';
import store from "Js/store";
import { errorHandler } from "Js/errorHandler";


const BF = {};

//Uuid
BF.getUUID = Uuid

BF.errorThrow = function() {
    errorHandler(arguments);
};

BF.errorClearAll = function() { store.dispatch('ERROR_CLEAR'); };

BF.errorGetAll = function() {return store.state.site.errors;};

// Conenction
BF.socketDisconnect = function() { socket.disconnect() }
BF.socketConnect = function() { socket.connect() }

// Query
BF.getQueryParam = function(key) {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars[key];
}

// ACTIONS
BF.actionsClear = function(action) {
    store.dispatch('ACTIONS_CLEAR', action)
}

BF.namedAction = function(name,options) {
    try {
        typeof options !== "object" && typeof options !== "undefined" ? options = JSON.parse(options) : null
        store.dispatch('ACTIONS_QUEUE', [ {action: "namedAction" , name, options } ])
    }
    catch (e) {
        BF.errorThrow(10159, 'String passed to BF.namedAction is not a valid JSON', 'BF.namedAction invalid parameter')
    }
}

// Misc
BF.i18n = function(key) {
    var _app = vueapp.$store.state.site.content.app
    var langSelected = _app.i18n.langSelected
    var langDefault = _app.i18n.langDefault
    if (typeof key == "undefined" || _.isEmpty(key)) { return '' }
    return _.get(_app.i18n.dict, [key, langSelected]) ||
        _.get(_app.i18n.dict, [key, langDefault]) ||
        'No default lang value or invalid key'
}

BF.rebuildReactivity = function(m) {
    for (const [key, value] of Object.entries(m)) {
        const item = m[key]
        if (item && typeof item === 'object') {
            BF.rebuildReactivity(item)
        }
        if (!Object.getOwnPropertyDescriptor(m, key).get) {
            delete m[key]
            Vue.set(m, key, value)
        }
    }
    return m
};

BF.pwaSetManifest = async function(manifest) {
    //Add Manifest
    let content = encodeURIComponent(JSON.stringify(manifest));
    let url = "data:application/manifest+json," + content;
    let element = document.createElement('link');
    element.setAttribute('rel', 'manifest');
    element.setAttribute('href', url);
    document.querySelector('head').appendChild(element);
};


/*===============================*/
window.bf = window.BF = BF

export default BF;